// viewer.labels.js — display labels for panoramas.
//
// Ingest hardcodes no name and ids are filename stems; real capture files
// are all named sphere.jpg, so every label used to read "sphere". Labels are
// synthesized viewer-side (not at ingest) because the video-relative time
// needs the track, and because this fixes already-published flights without
// a republish. Shared by the viewer markers, the PSV caption, and the web
// KML export (@viewer-labels alias).

const GENERIC_ID_RE = /^(sphere|pano(rama)?|img|image|photo|untitled)[-_ ]?\d*$/i;

export function fmtPanoTime(s) {
  const total = Math.max(0, Math.floor(s));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const sec = total % 60;
  const two = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${two(m)}:${two(sec)}` : `${m}:${two(sec)}`;
}

export function prettifyStem(id) {
  return id
    .replace(/[-_]+/g, " ")
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

// 1-based ordinals ordered by capturedAt ascending; undated entries keep
// manifest order after all dated ones. Stable for ties.
export function panoOrdinals(panoramas) {
  const order = panoramas.map((p, i) => ({ id: p.id, at: p.capturedAt ?? null, i }));
  order.sort((a, b) => {
    if (a.at !== null && b.at !== null && a.at !== b.at) return a.at < b.at ? -1 : 1;
    if (a.at !== null && b.at === null) return -1;
    if (a.at === null && b.at !== null) return 1;
    return a.i - b.i;
  });
  const ordinals = new Map();
  order.forEach((e, idx) => ordinals.set(e.id, idx + 1));
  return ordinals;
}

export function panoLabel(pano, ordinal, snappedTimeS) {
  if (pano.name) return pano.name;
  if (pano.id && !GENERIC_ID_RE.test(pano.id)) return prettifyStem(pano.id);
  const base = `Pano ${ordinal}`;
  return typeof snappedTimeS === "number" && Number.isFinite(snappedTimeS)
    ? `${base} — ${fmtPanoTime(snappedTimeS)}`
    : base;
}
